import React from "react";
import PageHero from "../components/PageHero";
import Seo from "../components/seo/Seo";
import JsonLd from "../components/seo/JsonLd";
import { MediaPieces } from "../components/Media";
import { InterestCta, TextLink } from "../components/Bits";
import { Reveal } from "../components/Decorative";
import { ROUTES, breadcrumbs } from "../lib/seo";

export default function MediaCoverage() {
  return (
    <>
      <Seo route={ROUTES.media} />
      <JsonLd data={breadcrumbs([{ name: ROUTES.media.crumb, path: ROUTES.media.path }])} />

      <PageHero
        eyebrow="Media & Coverage"
        title={<>What the papers <span className="gold-grad italic">made of it</span></>}
        intro="Headlines as they were published, in the language they were published in. Where a piece ran only in print, the cutting is here as it appeared."
      >
        <p className="mt-3 font-body text-base" style={{ color: "#E8D9C5" }}>
          <TextLink to={ROUTES.pillar.path}>
            <span style={{ color: "#E5C880" }}>What is bhajan jamming?</span>
          </TextLink>
        </p>
      </PageHero>

      <MediaPieces />

      <section className="bg-cream py-20 md:py-28 px-6">
        <div className="max-w-3xl mx-auto text-center">
          <Reveal>
            <InterestCta note="Come and be in the room for the next one." />
          </Reveal>
        </div>
      </section>
    </>
  );
}
